import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaFileInvoiceDollar, FaPlus } from 'react-icons/fa';

function Navigation() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <Navbar expand="md" className="navbar mb-4">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="fw-bold text-primary">
          Invoice App
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/"
              className={`d-flex align-items-center ${isActive('/') ? 'active' : ''}`}
            >
              <FaHome className="me-2" />
              Dashboard
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/invoices"
              className={`d-flex align-items-center ${isActive('/invoices') ? 'active' : ''}`}
            >
              <FaFileInvoiceDollar className="me-2" />
              Invoices
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/invoices/new"
              className={`d-flex align-items-center ${isActive('/invoices/new') ? 'active' : ''}`}
            >
              <FaPlus className="me-2" />
              New Invoice
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation; 